<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M16.809 66.143c.39-.306.585-.731.585-1.276 0-.546-.19-.967-.573-1.264-.383-.298-.906-.446-1.571-.446h-2.967v3.445h2.967c.648 0 1.168-.153 1.559-.459"
      />
      <path
        d="M48.864 71.781c.947.893 2.103 1.339 3.466 1.339 1.163 0 2.086-.273 2.768-.818v-5.676h4.513v7.708c-.698.76-1.704 1.413-3.017 1.958a11.564 11.564 0 0 1-4.264.793c-2.693 0-4.954-.842-6.783-2.528-1.812-1.701-2.718-3.866-2.718-6.493 0-2.644.914-4.808 2.743-6.494 1.812-1.685 4.123-2.528 6.932-2.528 1.812 0 3.508.414 5.087 1.24v4.188c-1.612-.875-3.2-1.313-4.762-1.313-1.58 0-2.877.462-3.89 1.387-.998.926-1.497 2.124-1.497 3.594 0 1.537.474 2.751 1.422 3.643zm-24.687 4.957V59.39h3.84l7.63 9.542V59.39h4.39v17.35H36.32l-7.73-9.592v9.591h-4.414zm47.03 16.744H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.155 61.586c0 2.275-1.858 4.125-4.145 4.125zM7.794 76.738V59.39h7.78c1.962 0 3.507.505 4.638 1.512 1.147 1.008 1.72 2.314 1.72 3.916 0 1.603-.573 2.916-1.72 3.94-1.13 1.009-2.676 1.513-4.638 1.513h-3.291v6.468h-4.49zM56.48 0H16.07C10.166 0 5.36 4.78 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M45.777 28.58a2.406 2.406 0 0 0-1.87.69l-3.095 3.099-7.889-7.842a2.406 2.406 0 0 0-1.703-.715 2.404 2.404 0 0 0-1.726.859l-11.99 14.3a2.373 2.373 0 0 0 .303 3.357c.4.333.9.527 1.423.552h33.573a2.39 2.39 0 0 0 2.398-2.384c0-.515-.169-1.017-.48-1.43l-7.194-9.533a2.401 2.401 0 0 0-1.75-.954M43.21 14.279c2.65 0 4.797 2.134 4.797 4.767 0 2.632-2.148 4.766-4.796 4.766-2.65 0-4.796-2.134-4.796-4.766 0-2.633 2.147-4.767 4.796-4.767"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-png',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
